import React, { useState } from 'react';

import { CursosGrid } from './BuscadorCursos/CursosGrid';
import { SearchCategory } from './BuscadorCursos/SearchCategory';

function ResultadosBusqueda () {

    const [categories, setCategories] = useState([]);

    return (
        <>
            <SearchCategory setCategories={ setCategories } />

            <div className='resultados_area portafolio_content'>
            
                <ol>
                    
                    {
                        categories.map( category => (
                            <CursosGrid
                                key={ category }
                                category={ category }
                            />
                        ))
                    }

                </ol>

            </div>
        </>
    );
}

export default ResultadosBusqueda;